module.exports = __webpack_public_path__ + "media/images/partners/4-374a7ac68de2d1f84080740beb26eb63.png";